module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {}, [_c('div', {
    staticClass: "container"
  }, [_c('figure', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "/static/images/index/i80banner.png"
    }
  })])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "container"
  }, [_c('ol', {
    staticClass: "breadcrumb hidden-xs"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("首頁")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("聯盟經營者")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("內文")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('div', {
    staticClass: "aside_menu"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("關於我們")]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, [_c('li', {
    staticClass: "active item"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("聯盟推廣者")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('article', [_c('h4', {
    staticClass: "title"
  }, [_vm._v("為甚麼要推廣i80?")]), _vm._v(" "), _c('div', {
    staticClass: "editor"
  }, [_vm._v("\n                      由於我們處於百物齊漲，唯獨薪水不增的時代，我們工作都是為了要賺錢養家，但是有沒有更好的方法邦你降低支出呢?\n                      目前有許多的通路都是剝削消費者居多並未考量消費者所需而設立，而我們愛幫您就是希望能提供第三方的公正平台來邦助消費者，\n                      邦助商品的把關與降低消費者的支出。"), _c('br'), _vm._v("那為甚麼消費者要推廣愛幫您呢?\n                      推廣i80的福利，首先自己加入i80就享有個人回饋，所以只要在i80平台消費是比外面還便宜的，\n                      此外透過您推薦的朋友加入後，往後任何消費我們都將再額外回饋廣告行銷費用給您而且這都是永久不變的。\n                      另外我們不時舉辦各種會員的活動與聚會，讓我們i80的會員們能像一個大家庭一樣，一起消費一起買到便宜又好的商品。\n                      ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "editor"
  }, [_vm._v("\n                      如果您覺得這個平台實在太好了，請先加入成為我們的會員，並介紹你的朋友讓他也加入成為會員，\n                      加入後您便是i80消費者聯盟的一份子。成為會員後，在聯盟的店家或是網路商品購買產品即有回饋點數。\n                      ")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1936af3f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Operators.vue
// module id = 283
// module chunks = 1